import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntBasicHB } from "../handBooks/basicHB";
import { EntTypeProduct } from "../handBooks/typeProduct";
import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntUnitMeasurement } from "../handBooks/unitMeasurement";

export class EntProcessingCompanies {
  id: number|null = null;
  companyName: string|null = null;
  legalFormId: number|null = null;
  industryTypeId: number|null = null;
  regionId: number|null = null;
  areaId: number|null = null;
  territorialUnitId: number|null = null;
  address: string|null = null;
  latitude: number|undefined = undefined;
  longitude: number|undefined = undefined;
  registrationDate: string|null = null;
  statusId: number|null = null;
  
  processingCapacities: EntProcessingCapacity[] = [];
  files?: EntFiles[];
  deleteFileIds?: number[];

  region?: EntTerritorialsUnits;
  area?: EntTerritorialsUnits;
  territorialUnit?: EntTerritorialsUnits;
  legalForm?: EntDirectoryInfoName;
  industryType?: EntDirectoryInfoName;
  status?: EntBasicHB;
}

export class EntProcessingCapacity {
  id: number|null = null;
  productTypeId: number|null = null;
  dailyCapacity: number|null = null;
  unitMeasurementId: number|null = null;
  companyId: number|null = null;
  loadPercentage: number|null = null;
  yearReported: number|null = null;

  productType?: EntTypeProduct;
  unitMeasurement?: EntUnitMeasurement;
}

export class EntFiles {
  id: number|null = null;
  name: string|null = null;
  path: string|null = null;
  pathCropped: string|null = null;
  extension: string|null = null;
  type: string|null = null;
  createdTime: string|null = null;
}